import {
    AlertDescription, AlertTitle, Box, Alert as ChakraAlert,
    Flex,
} from '@chakra-ui/react';
import {
    faCheckCircle, faExclamationCircle, faExclamationTriangle,
    faInfoCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { FaIcon, FaIconProps } from '../fa-icon';

type AlertStatus = 'error' | 'warning' | 'info' | 'success';

function getAlertIcon(status: AlertStatus) {
    switch (status) {
        case 'error':
            return faExclamationCircle;
        case 'warning':
            return faExclamationTriangle;
        case 'success':
            return faCheckCircle;
        case 'info':
        default:
            return faInfoCircle;
    }
}

function getAlertColorScheme(status: AlertStatus) {
    switch (status) {
        case 'error':
            return 'danger';
        case 'warning':
            return 'warning';
        case 'success':
            return 'success';
        case 'info':
        default:
            return 'info';
    }
}

export function Alert({
    title,
    children,
    status = 'info',
    icon,
    aside,
    ...props
}: {
    title?: string;
    children?: React.ReactNode;
    icon?: FaIconProps['icon'];
    status?: AlertStatus;
    aside?: React.ReactNode;
} & Omit<React.ComponentProps<typeof ChakraAlert>, 'status'>) {
    return (
        <ChakraAlert {...props} colorScheme={getAlertColorScheme(status)}>
            <Flex mr={4}>
                <FaIcon h="1.2em" w="1.2em" icon={icon ?? getAlertIcon(status)} />
            </Flex>
            <Box flexGrow={1}>
                <AlertTitle fontWeight={(children ?? null) !== null ? 'bold' : 'medium'}>{title}</AlertTitle>
                <AlertDescription>
                    {children}
                </AlertDescription>
            </Box>
            {aside}
        </ChakraAlert>
    );
}
